import React from 'react';
import PropTypes from 'prop-types';

const RepeatInterval = (props) => {
  const {
    updateField, active, value, disabled,
  } = props;
  return (
    <div style={{ width: '150px' }}>
      <div className="row form-inline">
        <span className="col-lg-12" style={{ fontWeight: 'bold', fontSize: '15px' }}>Repeat Interval</span>
      </div>
      <div className="row form-inline-block">
        <div className="col-lg-12">
          <input
            className="form-check  mr-2 mx-2 d-inline-block"
            type="checkbox"
            checked={active}
            disabled={disabled}
            onChange={(e) => {
              updateField('repeatEnabled', (e.target.checked));
            }}
            aria-label="enable repeat interval"
          />
          <input
            className="form-control mx-2 d-inline-block"
            onChange={(e) => {
              updateField('repeatInterval', e.target.value);
            }}
            disabled={disabled || !active}
            value={value}
            type="text"
            style={{ width: '4em' }}
            aria-label="repeat interval time in minutes"
          />
          <span>min.</span>
        </div>
      </div>
    </div>
  );
};

RepeatInterval.propTypes = {
  updateField: PropTypes.func.isRequired,
  active: PropTypes.bool.isRequired,
  value: PropTypes.number.isRequired,
  disabled: PropTypes.bool.isRequired,
};
export default RepeatInterval;
